import { Component } from '@angular/core';

@Component({
  selector: 'app-applypage',
  templateUrl: './applypage.component.html',
  styleUrl: './applypage.component.scss'
})
export class ApplypageComponent {

}
